import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";
import { images } from "../../assets/images";
import AppModal from "../../components/AppModal";

const CONDITION_SCALE = [
  { label: "Danger", color: "#ff0000", background: "#ff000020" },
  { label: "Poor", color: "#ff8c00", background: "#ff8c0020" },
  { label: "Fair", color: "#ffd700", background: "#ffd70020" },
  { label: "Good", color: "#008000", background: "#00800020" },
  { label: "Excellent", color: "#0000ff", background: "#0000ff20" },
];

const CONDITION_COLORS = CONDITION_SCALE.reduce((acc, item) => {
  acc[item.label.toLowerCase()] = item.color;
  return acc;
}, {});

const EndJob = () => {
  const { getServiceList, getServiceDetails, sendAssessmentReport } =
    useGlobal();
  const location = useLocation();
  const totalPrice = location.state?.total_price;
  const jobPid = location.state?.job_pid;
  const navigate = useNavigate();
  const [endJobData, setEndJobData] = useState([]);
  const [conditionScale, setConditionScale] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const services = await getServiceList(jobPid);
      setEndJobData(services);

      if (services?.length > 0) {
        const details = await getServiceDetails(
          services[0].service_pid,
          jobPid,
        );

        if (details?.content?.length > 0) {
          setConditionScale(
            details.content.map((item) => ({
              label:
                item?.condition.charAt(0).toUpperCase() +
                item?.condition.slice(1),
              color: item?.color,
            })),
          );
        }
      }
    };
    fetchData();
  }, []);

  const allAssessed =
    endJobData?.length > 0 && endJobData.every((item) => item?.status);

  return (
    <div className="content-part2 d-flex justify-content-center">
      <div className="content-main px-3">
        {/* Instruction Banner */}
        <div className="ej-banner mb-3">
          <div className="ej-banner-icon">
            <i className="fa-solid fa-clipboard-check"></i>
          </div>
          <div>
            <h6 className="fw-bold mb-1" style={{ color: "#0d1831" }}>
              Property Inspection
            </h6>
            <p className="mb-0 fs-13 text-secondary">
              Walk the property and rate each exterior area to ensure the
              highest quality of service.
            </p>
          </div>
        </div>

        <p className="fs-13 text-secondary mb-3">
          <i className="fa-solid fa-circle-info me-1"></i>
          Rating every area is mandatory to generate the property inspection
          report, which will be emailed to the customer.
        </p>

        {/* Condition Scale Legend */}
        <div className="mb-4">
          <p
            className="fw-bold fs-11 text-uppercase mb-2"
            style={{ color: "#9ca3af", letterSpacing: "0.8px" }}
          >
            Condition Scale
          </p>
          <div className="ej-scale-row">
            {conditionScale.map((item) => (
              <div
                key={item.label}
                className="ej-scale-pill"
                style={{
                  backgroundColor: `${item.color}20`,
                  color: item.color,
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        </div>

        {/* Service List */}
        <div className="d-flex flex-column gap-3">
          {endJobData?.map((item) => (
            <div
              key={item.service_pid}
              className="ej-service-card"
              onClick={() =>
                navigate("/end-job-details", {
                  state: {
                    job_pid: jobPid,
                    service_pid: item.service_pid,
                  },
                })
              }
            >
              <div className="ej-service-img">
                <img
                  src={item.image || images.placeHolderImg}
                  alt={item.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = images.placeHolderImg;
                  }}
                />
              </div>
              <div className="d-flex align-items-center justify-content-between w-100">
                <h6
                  className="fw-bold mb-1"
                  style={{ fontSize: "15px", color: "#0d1831" }}
                >
                  {item.name}
                </h6>
                <div className="d-flex align-items-center gap-3">
                  {item?.status &&
                    (() => {
                      const statusColor =
                        item.status.color ||
                        CONDITION_COLORS[item.status.condition];

                      return (
                        <span
                          className="ej-status-badge"
                          style={{
                            background: `${statusColor}18`,
                            color: statusColor,
                            border: `1px solid ${statusColor}30`,
                          }}
                        >
                          {item.status.condition.charAt(0).toUpperCase() +
                            item.status.condition.slice(1)}
                        </span>
                      );
                    })()}
                  <div className="ej-arrow-btn">
                    <i
                      className="fa-solid fa-chevron-right"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-primary px-4 py-2"
            disabled={!allAssessed || isSubmitting}
            onClick={async () => {
              setIsSubmitting(true);
              const response = await sendAssessmentReport(jobPid);
              setIsSubmitting(false);

              if (response) {
                setShowSuccessModal(true);
              }
            }}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>

      <AppModal
        type="job-submitted"
        show={showSuccessModal}
        amount={totalPrice}
        onClose={() => setShowSuccessModal(false)}
        onConfirm={() => {
          setShowSuccessModal(false);
          navigate("/home");
        }}
      />
    </div>
  );
};

export default EndJob;
